/* eslint-disable no-nested-ternary */
import { Button, Divider, Grid } from '@material-ui/core';
import { Modal, TextFieldPx, useMutation, useToast, useAuth } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import PasswordUpdate from './components/PasswordUpdate';
import { changeMail, confirmChangeEmailCode, changeMailOnBackend, changePhoneOnBackend, changeNameOnBackend } from '@webapps/business';
import { ExitToApp } from '@material-ui/icons';
import PhoneInput, {
  isValidPhoneNumber,
} from 'react-phone-number-input';

const Account = ({ accountInfos = [], refetchAccountInfo }) => {
  const {
    classes,
    cx,
    css,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [originalEmail, setOriginalEmail] = useState(accountInfos?.email);
  const [email, setEmail] = useState("");
  const [originalPhone, setOriginalPhone] = useState(accountInfos?.phone);
  const [phone, setPhone] = useState("");
  const [firstname, setFirstname] = useState(accountInfos?.firstname);
  const [lastname, setLastname] = useState(accountInfos?.lastname);
  const [errorPhone, setErrorPhone] = useState(false);
  const [phoneInput, setPhoneInput] = useState(false);
  const [code, setCode] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [phoneClasses, setPhoneClasses] = useState('phoneInput');
  const phoneClassesRef = useRef();
  phoneClassesRef.current = phoneClasses;

  const { addToast } = useToast();
  const { idUser, profile } = useAuth();

  const {
    error: errorRequest,
    isLoading: isLoadingUpdate,
    isSuccess,
    mutate: mutateChangeMail,
  } = useMutation(changeMail);

  const {
    error: errorRequestConfirmCode,
    isLoading: isLoadingUpdateConfirmCode,
    isSuccess: isSuccessConfirmCode,
    mutate: mutateConfirmCodeMail,
  } = useMutation(confirmChangeEmailCode);

  const {
    error: errorRequestChangeMailBackend,
    isLoading: isLoadingChangeMailBackend,
    isSuccess: isSuccessChangeMailBackend,
    mutate: mutateChangeMailBackend,
  } = useMutation(changeMailOnBackend);

  const {
    error: errorRequestChangePhoneBackend,
    isLoading: isLoadingChangePhoneBackend,
    isSuccess: isSuccessChangePhoneBackend,
    mutate: mutateChangePhoneBackend,
  } = useMutation(changePhoneOnBackend);

  const {
    error: errorRequestChangeNameBackend,
    isLoading: isLoadingChangeNameBackend,
    isSuccess: isSuccessChangeNameBackend,
    mutate: mutateChangeNameBackend,
  } = useMutation(changeNameOnBackend);

  const handleChangeEmail = async () => {
    await mutateChangeMail({
      email,
    });
  };

  const handleConfirmCode = async () => {
    await mutateConfirmCodeMail({
      code,
    });
  };

  const handleChangePhone = (phoneInfo) => {
    if (phoneInfo) {
      setPhone(phoneInfo);
      if (isValidPhoneNumber(phoneInfo)) {
        setErrorPhone(false);
        setPhoneClasses('phoneInput');
      } else {
        setErrorPhone(true);
        setPhoneClasses('phoneInputError');
      }
    }
  };

  const handleLogOutOnClick = () => {
    disconnect();
    logout();
  };

  useEffect(() => {
    if (accountInfos?.email) {
      setOriginalEmail(accountInfos?.email);
      setEmail(accountInfos?.email);
    }
    if (accountInfos?.phone) {
      setOriginalPhone(accountInfos?.phone);
      setPhone(accountInfos?.phone);
    }
    if(accountInfos?.firstname){
      setFirstname(accountInfos?.firstname);
    }
    if(accountInfos?.lastname){
      setLastname(accountInfos?.lastname);
    }
  }
    , [accountInfos]);

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Vous avez reçu un code',
      });
      setCodeSent(true);
    }
  }, [isSuccess]);

  useEffect(async () => {
    if (isSuccessConfirmCode) {
      await mutateChangeMailBackend({
        email: email,
        id: idUser,
      });
    }
  }, [isSuccessConfirmCode]);

  useEffect(async () => {
    if (isSuccessChangeMailBackend) {
      addToast({
        status: 'success',
        message: 'Votre e-mail a été mis à jour',
      });
      refetchAccountInfo();
      setCodeSent(false);
    }
    if (isSuccessChangePhoneBackend) {
      addToast({
        status: 'success',
        message: 'Votre numéro de téléphone a été mis à jour',
      });
      refetchAccountInfo();
      setPhoneInput(false);
    }
    if (isSuccessChangeNameBackend) {
      addToast({
        status: 'success',
        message: 'Vos infos ont été mises à jour',
      });
      refetchAccountInfo();
    }

  }, [isSuccessChangeMailBackend, isSuccessChangePhoneBackend, isSuccessChangeNameBackend]);

  useEffect(() => {
    if (errorRequestConfirmCode) {
      addToast({
        status: 'error',
        message: 'Le code est incorrect',
      });
    }
    if (errorRequestChangeMailBackend || errorRequestChangePhoneBackend || errorRequestChangeNameBackend) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  }, [errorRequestConfirmCode, errorRequestChangeMailBackend, errorRequestChangePhoneBackend, errorRequestChangeNameBackend]);
  

  return (
    <Grid spacing={3} xs={12} className={classes.container}>
      <Grid item md={6} className={classes.card}>
        <div style={{ marginBottom: spacing(2.5) }} className={global.title}>Informations de compte</div>
        {accountInfos?.childClass !== 'IndividualAccount' ? (
          <Grid item xs={12} className={classes.textfield}>
            <TextFieldPx
              fullWidth
              disabled
              label={<FormattedMessage id="Nom d'établissement" />}
              name="label"
              borderRadius={6}
              inputProps={{
                className: cx(classes.infoBox, classes.infoBoxDisabled)
              }}
              value={accountInfos?.name}
              variant="filled"
            />
          </Grid>
        ) : (
          <Grid container xs={12} className={classes.btnsContainer2}>
            <Grid item xs={6} className={cx(classes.textfield, classes.textfieldName)}>
              <TextFieldPx
                fullWidth
                borderRadius={6}
                label={<FormattedMessage id="Prénom" />}
                name="firstname"
                inputProps={{
                  className: cx(classes.infoBox)
                }}
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                onBlur={async () => { await mutateChangeNameBackend({ firstname: firstname, lastname: lastname, id: idUser }) }}
                variant="filled"
              />
            </Grid>
            <Grid item xs={6} className={cx(classes.textfield, classes.textfieldName)}>
              <TextFieldPx
                fullWidth
                borderRadius={6}
                label={<FormattedMessage id="Nom" />}
                name="lastname"
                inputProps={{
                  className: cx(classes.infoBox)
                }}
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                onBlur={async () => { await mutateChangeNameBackend({ firstname: firstname, lastname: lastname, id: idUser }) }}
                variant="filled"
              />
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} className={classes.textfield}>
          <PhoneInput
            disabled={profile === 'SCHOOL' || profile === 'BUSINESS'}
            className={`${classes[phoneClassesRef.current]}`}
            countryCallingCodeEditable={false}
            defaultCountry="FR"
            international
            limitMaxLength
            name="phone"
            onChange={(phone) => {
              handleChangePhone(phone);
            }}
            placeholder={<FormattedMessage id="createUserForm.phone" />}
            value={phone}
          />
        </Grid>
        {(phone && phone !== originalPhone) && (
          <Grid item xs={12} className={classes.textfield} >
            <Button
              disabled={errorPhone || isLoadingChangePhoneBackend}
              color="primary"
              variant='contained'
              onClick={async () => { await mutateChangePhoneBackend({ phone: phone, id: idUser }) }}
            >
              Enregistrer
            </Button>
            <Button
              className={classes.btnCancel}
              color="primary"
              variant='contained'
              onClick={() => { setPhone(originalPhone), setPhoneClasses('phoneInput') }}
            >
              Annuler
            </Button>
          </Grid>
        )}
        <Grid item xs={12} className={classes.textfield}>
          <TextFieldPx
            fullWidth
            borderRadius={6}
            label={<FormattedMessage id="E-mail" />}
            name="email"
            inputProps={{
              className: cx(classes.infoBox)
            }}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            variant="filled"
          />
        </Grid>
        {(email && email !== originalEmail) && (
          <Grid item xs={12} className={classes.textfield} >
            <Button
              color="primary"
              variant='contained'
              onClick={handleChangeEmail}
            >
              Envoyer le code
            </Button>
            <Button
              className={classes.btnCancel}
              color="primary"
              variant='contained'
              onClick={() => setEmail(originalEmail)}
            >
              Annuler
            </Button>
          </Grid>
        )}
      </Grid>
      <Modal
        onCancel={() => setCodeSent(false)}
        open={codeSent}
        title="Veuillez confirmer votre code"
      >
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <div>
              Veuillez vérifier votre e-mail : {email}, pour le
              code de confirmation.
            </div>
          </Grid>
          <Grid item xs={12}>
            <TextFieldPx
              fullWidth
              borderRadius={6}
              label={<FormattedMessage id="code" />}
              name="code"
              type="tel"
              onChange={(e) => setCode(e.target.value)}
              value={code}
            />
          </Grid>
          <Grid className={css({ marginTop: spacing(2) })} xs={6}>
            <Button
              className={css({ borderRadius: '6px' })}
              color="primary"
              disabled={
                isLoadingUpdateConfirmCode || isLoadingChangeMailBackend
              }
              fullWidth
              onClick={handleConfirmCode}
              variant="contained"
            >
              <FormattedMessage id="btnConfirm" />
            </Button>
          </Grid>
        </Grid>
      </Modal>
      <Grid item md={6} className={classes.card}>
        <div style={{ marginBottom: spacing(2.5) }} className={global.title}>Changer votre mot de passe</div>
        <PasswordUpdate />
        <div className={classes.btnsContainer2}>
          <div className={classes.btnLogoutContainer}>
            <Button
              className={classes.btnLogout}
              color="primary"
              variant='outlined'
              onClick={handleLogOutOnClick}
              startIcon={<ExitToApp />}
            >
              <FormattedMessage id="sidebar.logout" />
            </Button>
            <Button
              className={classes.btnDelete}
              color="primary"
              variant='contained'
              onClick={() => setOpenModal(true)}
            >
              Supprimer mon compte
            </Button>
            <Modal
              open={openModal}
              onCancel={() => setOpenModal(false)}
              title="Veuillez contacter le support pour supprimer votre compte"
            >
              <div className={classes.buttonContainer}>
                <div className={classes.deleteAccount}>
                  Veuillez contacter <b>support@linkpick.fr</b> pour faire votre demande de suppression de compte (Cette action est irréversible)
                </div>
                <Button
                  color="primary"
                  variant='contained'
                  onClick={() => setOpenModal(false)}
                >
                  C'est compris !
                </Button>
              </div>
            </Modal>
            <div className={classes.cgu}>
              <a href="https://linkpick.fr/conditions-generales-utilisation/" target="_blank"> Lire nos CGU </a>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    width: '49%',
    flexBasis: '49%',
    padding: spacing(2.5),
    '@media only screen and (max-width:1023px)': { width: '100%', flexBasis: '100%', marginBottom: '16px' },
  },
  cgu: {
    color: '#0060F9',
    padding: '16px 0',
    alignSelf: 'self-end',
    '@media only screen and (max-width:1023px)': { alignSelf: 'self-start', marginLeft: 0 },
  },
  password: {
    marginLeft: spacing(2.5),
    marginBottom: spacing(2.5),
  },
  textfield: {
    marginBottom: spacing(2.5),
    flexBasis: 'auto',
  },
  textfieldName: {
    width: '49%',
  },
  infoBox: {
    borderRadius: '5px',
    color: '#152652',
    "-webkit-text-fill-color": "#152652",
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontFamily: 'Montserrat',
    height: '30px',
    backgroundColor: '#F3F7FF',
    display: 'flex',
    alignItems: 'center',
  },
  infoBoxDisabled: {
    borderRadius: '5px',
    color: '#5D75A8',
    backgroundColor: '#FFFFFF',
  },
  btnCancel: {
    marginLeft: spacing(2),
    backgroundColor: 'crimson',
  },
  btnDelete: {
    marginTop: spacing(2.5),
    float: 'right',
    backgroundColor: 'crimson',
    '@media only screen and (max-width:506px)': { width: '100%', flexBasis: '100%' },
  },
  deleteAccount: {
    textAlign: 'center',
    marginBottom: '16px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  btnLogout: {
    marginTop: spacing(2.5),
    backgroundColor: 'white',
    '@media only screen and (max-width:506px)': { width: '100%', flexBasis: '100%' },
  },
  btnLogoutContainer: {
    width: '100%',
    display: 'flex',
    gap: '10px',
    alignItems: 'self-end',
    flexWrap: 'wrap',
  },
  btnsContainer2: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  phoneInput: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F3F7FF',
      border: "1px solid #C0D9FF",
      borderRadius: 5,
      padding: spacing(0, 2),
      height: '60px',
      color: '#737373',
    },
  },
  phoneInputError: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F3F7FF',
      border: '1px solid red',
      borderRadius: 5,
      padding: spacing(0, 2),
      height: '60px',
      color: '#f44336',
    },
  },
  phoneError: {
    display: 'flex',
    width: '100%',
    '& > *': {
      width: '50%',
    },
  },
  phoneDisabled: {
    '& > *': {
      backgroundColor: 'white',
    },
  }
});

Account.propTypes = {
  accountInfos: PropTypes.object,
  refetchAccountInfo: PropTypes.func,
};

export default Account;
